
const BASE_API_URL =process.env.REACT_APP_SERVER;

export default BASE_API_URL;

export const MEDIA_BASE_URL = "https://basketballinstructionstatenisland.com";

export const STRIPE_PUBLISHABLE_KEY = "pk_live_kmRs3Che0kgmQCd6TD4whp2N"
